import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip, } from "chart.js";
import moment from "moment";
import { memo, useContext, useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { convertNumberToShortText, intComma } from "src/utils/methods";
import { render } from "react-dom";
import styles from "./fii.module.scss";
import { ThemeContext } from "src/contexts/theme-context";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
const FIIChart = ({ data, range }) => {
    // const chartRef = useRef();
    const [dataset, setDataset] = useState();
    const theme = useContext(ThemeContext);
    const getOrCreateTooltip = (chart, tooltip) => {
        var _a, _b, _c;
        let tooltipEl = (_a = chart.canvas) === null || _a === void 0 ? void 0 : _a.parentNode.querySelector("div");
        const index = tooltip.dataPoints[0].datasetIndex;
        const value = chart.config.data.datasets[index].data[0];
        const key = Object.keys(data);
        const dataObj = data[key[0]];
        const valBuy = index == 0
            ? dataObj.DII_PROV_EQTY_BUY
            : index == 1
                ? dataObj.FII_PROV_EQTY_BUY
                : index == 2
                    ? dataObj.FII_FNO_INDEX_FUT_BUY
                    : index == 3
                        ? dataObj.FII_FNO_STOCK_FUT_BUY
                        : index == 4
                            ? dataObj.FII_FNO_INDEX_OPT_BUY
                            : index == 5
                                ? dataObj.FII_FNO_STOCK_OPT_BUY
                                : 0;
        const valSell = index == 0
            ? dataObj.DII_PROV_EQTY_SELL
            : index == 1
                ? dataObj.FII_PROV_EQTY_SELL
                : index == 2
                    ? dataObj.FII_FNO_INDEX_FUT_SELL
                    : index == 3
                        ? dataObj.FII_FNO_STOCK_FUT_SELL
                        : index == 4
                            ? dataObj.FII_FNO_INDEX_OPT_SELL
                            : index == 5
                                ? dataObj.FII_FNO_STOCK_OPT_SELL
                                : 0;
        // console.log(chart,tooltip);
        if (!tooltipEl) {
            tooltipEl = document.createElement("div");
        }
        tooltipEl.style.pointerEvents = "none";
        //Need UI Review Here
        render(_jsxs("div", Object.assign({ className: styles.fiiTooltip }, { children: [_jsxs("span", Object.assign({ className: "section" }, { children: [_jsx("span", Object.assign({ className: "fixedText" }, { children: "Total Buy" })), _jsx("span", { children: ":" }), _jsx("span", Object.assign({ className: `valText net-buy` }, { children: (valBuy != null ? intComma(valBuy.toFixed(2)) : 0) + " CR" }))] })), _jsxs("span", Object.assign({ className: "section" }, { children: [_jsx("span", Object.assign({ className: "fixedText" }, { children: "Total Sell" })), _jsx("span", { children: ":" }), _jsx("span", Object.assign({ className: `valText net-sell` }, { children: (valSell != null ? intComma(valSell.toFixed(2)) : 0) + " CR" }))] })), _jsxs("span", Object.assign({ className: "section" }, { children: [_jsx("span", Object.assign({ className: "fixedText" }, { children: "Net" })), _jsx("span", { children: ":" }), _jsx("span", Object.assign({ className: `valText` }, { children: (value != null ? intComma(value.toFixed(2)) : 0) + " CR" }))] }))] })), tooltipEl);
        (_c = (_b = chart.canvas) === null || _b === void 0 ? void 0 : _b.parentNode) === null || _c === void 0 ? void 0 : _c.appendChild(tooltipEl);
        return tooltipEl;
    };
    const externalTooltipHandler = (context) => {
        // Hide if no tooltip
        const { chart, tooltip } = context;
        const tooltipEl = getOrCreateTooltip(chart, tooltip);
        if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = "0";
            return;
        }
        let offsetX = 0;
        let offsetY = 0;
        offsetX = 60;
        offsetY = 0;
        // if (tooltip.caretY < 50) {
        //   offsetY -= 50;
        // }
        if (tooltip.caretX > 300) {
            offsetX = 90;
        }
        const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
        // Display, position, and set styles for font
        tooltipEl.style.opacity = "1";
        tooltipEl.style.position = "absolute";
        // tooltipEl.style.left = positionX + tooltip.caretX + "px";
        // tooltipEl.style.top = positionY + tooltip.caretY + "px";
        tooltipEl.style.left = positionX + (tooltip.caretX - offsetX) + "px";
        tooltipEl.style.top = positionY + (tooltip.caretY - offsetY) + "px";
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        enabled: true,
        animations: {
            duration: 0,
        },
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
                intersect: false,
                external: externalTooltipHandler,
            },
            datalabels: {
                color: "blue",
                labels: {
                    title: "first",
                    value: "second",
                },
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    color: theme.theme == "dark" ? "#DBDFE7" : "#666666",
                },
            },
            y: {
                beginAtZero: true,
                grid: {
                    display: false,
                },
                ticks: {
                    color: theme.theme == "dark" ? "#DBDFE7" : "#666666",
                    callback: function (value) {
                        if (value >= 1000 && value < 100000) {
                            return (value / 1000).toFixed(1) + "K";
                        }
                        if (value >= 100000) {
                            return convertNumberToShortText(value);
                        }
                        if (value <= -1000 && value > -100000) {
                            return (value / 1000).toFixed(1) + "K";
                        }
                        if (value <= 100000) {
                            return convertNumberToShortText(value);
                        }
                        if (Number.isInteger(value)) {
                            return value;
                        }
                        return value.toFixed(2);
                    },
                },
                autoSkip: false,
                grace: "10%",
            },
        },
    };
    const indexArr = [
        "DII CASH*",
        "FII CASH*",
        "FII IDX FUT",
        "FII STK FUT",
        "FII IDX OPT",
        "FII STK OPT",
    ];
    const axisMarker = {
        id: "axisMarker",
        afterDatasetsDraw: (chart, args, plugins) => {
            const { ctx, chartArea: { top, right, bottom, left, width, height }, scales: { x, y }, } = chart;
            ctx.setLineDash([3, 3]);
            ctx.beginPath();
            ctx.strokeStyle = "rgba(136, 136, 136, 1)";
            ctx.lineWidth = 0.5;
            ctx.moveTo(left, y.getPixelForValue(0));
            ctx.lineTo(width + left, y.getPixelForValue(0));
            ctx.stroke();
            ctx.save();
        },
    };
    const setBarColor = (context, state) => {
        if (context && context.chart) {
            const chart = context.chart;
            const { ctx, chartArea, data, scales } = chart;
            let index = -1;
            if (state == "DII CASH*") {
                index = 0;
            }
            else if (state == "FII CASH*") {
                index = 1;
            }
            else if (state == "FII IDX FUT") {
                index = 2;
            }
            else if (state == "FII STK FUT") {
                index = 3;
            }
            else if (state == "FII IDX OPT") {
                index = 4;
            }
            else if (state == "FII STK OPT") {
                index = 5;
            }
            if (data.datasets[index].data.length > 0 &&
                data.datasets[index].data[0] > 0) {
                return "rgba(0, 178, 158, 1)";
            }
            else {
                return "rgba(229, 69, 93, 1)";
            }
        }
        else {
            return "";
        }
    };
    const setBarPositions = {
        id: "setBarPositions",
        beforeDatasetsDraw: (chart, args, plugins) => {
            const { ctx, data, chartArea: { top, bottom, left, right, width, height }, scales: { x, y }, } = chart;
            const offsetX = 0;
            const offsetY = 0;
            chart.config.data.datasets.forEach((_, index) => {
                const datapoint = chart.getDatasetMeta(index).data[0];
                if (datapoint) {
                    datapoint.x -= offsetX;
                }
            });
        },
        afterDatasetsDraw: (chart) => {
            const { ctx, data, chartArea: { top, bottom, left, right, width, height }, scales: { x, y }, } = chart;
            const offsetX = 30;
            const offsetY = 0;
            chart.config.data.datasets.forEach((_, index) => {
                const datapoint = chart.getDatasetMeta(index).data[0];
                if (datapoint) {
                    datapoint.x += offsetX;
                }
            });
            // chart.update();
        },
    };
    useEffect(() => {
        const labels = Object.keys(data);
        if (range == "1D") {
            const info = {
                labels: labels.map((label) => moment(label).format("DD MMM")),
                datasets: [
                    {
                        label: "DII CASH*",
                        data: labels.map((date) => data[date].DII_EQTY_PROV_NET),
                        // backgroundColor:
                        //   labels.map((date) => data[date].DII_EQTY_PROV_NET)[0] > 0
                        //     ? "rgba(0, 178, 158, 1)"
                        //     : "rgba(229, 69, 93, 1)",
                        backgroundColor: (context) => {
                            return setBarColor(context, "DII CASH*");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                        //hoverBackgroundColor: "#0080ff",
                    },
                    {
                        label: "FII CASH*",
                        data: labels.map((date) => data[date].FII_EQTY_PROV_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII CASH*");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII IDX FUT",
                        data: labels.map((date) => data[date].FII_FNO_INDEX_FUT_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII IDX FUT");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII STK FUT",
                        data: labels.map((date) => data[date].FII_FNO_STOCK_FUT_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII STK FUT");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII IDX OPT",
                        data: labels.map((date) => data[date].FII_FNO_INDEX_OPT_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII IDX OPT");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII STK OPT",
                        data: labels.map((date) => data[date].FII_FNO_STOCK_OPT_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII STK OPT");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                ],
            };
            setDataset(info);
        }
        else if (range == "1M") {
            const info = {
                labels: labels.map((label) => moment(label).format("MMM YY")),
                datasets: [
                    {
                        label: "DII CASH*",
                        data: labels.map((date) => data[date].DII_EQTY_PROV_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "DII CASH*");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII CASH*",
                        data: labels.map((date) => data[date].FII_EQTY_PROV_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII CASH*");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII IDX FUT",
                        data: labels.map((date) => data[date].FII_FNO_INDEX_FUT_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII IDX FUT");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII STK FUT",
                        data: labels.map((date) => data[date].FII_FNO_STOCK_FUT_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII STK FUT");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII IDX OPT",
                        data: labels.map((date) => data[date].FII_FNO_INDEX_OPT_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII IDX OPT");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII STK OPT",
                        data: labels.map((date) => data[date].FII_FNO_STOCK_OPT_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII STK OPT");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                ],
            };
            setDataset(info);
        }
        else if (range == "1Y") {
            const info = {
                labels: labels.map((label) => moment(label).format("YYYY")),
                datasets: [
                    {
                        label: "DII CASH*",
                        data: labels.map((date) => data[date].DII_EQTY_PROV_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "DII CASH*");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII CASH*",
                        data: labels.map((date) => data[date].FII_EQTY_PROV_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII CASH*");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII IDX FUT",
                        data: labels.map((date) => data[date].FII_FNO_INDEX_FUT_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII IDX FUT");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII STK FUT",
                        data: labels.map((date) => data[date].FII_FNO_STOCK_FUT_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII STK FUT");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII IDX OPT",
                        data: labels.map((date) => data[date].FII_FNO_INDEX_OPT_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII IDX OPT");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                    {
                        label: "FII STK OPT",
                        data: labels.map((date) => data[date].FII_FNO_STOCK_OPT_NET),
                        backgroundColor: (context) => {
                            return setBarColor(context, "FII STK OPT");
                        },
                        barPercentage: 0.6,
                        categoryPercentage: 1,
                    },
                ],
            };
            setDataset(info);
        }
        return () => {
            // chartRef.current = undefined;
        };
    }, [data]);
    if (dataset) {
        return _jsx(Bar, { options: options, data: dataset, plugins: [axisMarker] });
    }
    return null;
};
export default memo(FIIChart);
